import Vue from 'vue';
import VueRouter from 'vue-router';

import { authenticationGuard } from '@/authentication-guard';
import { UserRoleName } from '@/lib/models';

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: { name: 'application-modules' },
    },
    {
      path: '',
      component: () => import('@/views/AuthenticatedRoute.vue'),
      children: [
        {
          path: '/application-modules',
          name: 'application-modules',
          component: () => import('@/views/ApplicationModules.vue'),
          beforeEnter: authenticationGuard,
        },
        {
          path: '/companies',
          name: 'companies',
          component: () => import('@/views/Companies.vue'),
          beforeEnter: authenticationGuard,
          meta: { authorizedRoles: [UserRoleName.TraceAdmin, UserRoleName.SupportAccess] },
        },
        {
          path: '/companies/create',
          name: 'create-company',
          component: () => import('@/views/CreateCompany.vue'),
          beforeEnter: authenticationGuard,
          meta: { authorizedRoles: [UserRoleName.TraceAdmin] },
        },
        {
          path: '/companies/edit/:companyId',
          name: 'edit-company',
          component: () => import('@/views/EditCompany.vue'),
          beforeEnter: authenticationGuard,
          meta: { authorizedRoles: [UserRoleName.TraceAdmin, UserRoleName.SupportAccess] },
        },
        {
          path: '/users',
          name: 'users',
          component: () => import('@/views/Users.vue'),
          beforeEnter: authenticationGuard,
          meta: { authorizedRoles: [UserRoleName.TraceAdmin, UserRoleName.SupportAccess, UserRoleName.CompanyAdmin] },
        },
        {
          path: '/users/import',
          name: 'user-import',
          component: () => import('@/views/UserImport.vue'),
          beforeEnter: authenticationGuard,
          meta: { authorizedRoles: [UserRoleName.TraceAdmin, UserRoleName.SupportAccess, UserRoleName.CompanyAdmin] },
        },
        {
          path: '/user-groups',
          name: 'user-groups',
          component: () => import('@/views/UserGroups.vue'),
          beforeEnter: authenticationGuard,
          meta: { authorizedRoles: [UserRoleName.TraceAdmin, UserRoleName.SupportAccess, UserRoleName.CompanyAdmin] },
        },
        {
          path: '/user-groups/:userGroupId',
          name: 'user-group',
          component: () => import('@/views/UserGroup.vue'),
          beforeEnter: authenticationGuard,
          meta: { authorizedRoles: [UserRoleName.TraceAdmin, UserRoleName.SupportAccess, UserRoleName.CompanyAdmin] },
        },
        {
          path: '/user-roles',
          name: 'user-roles',
          component: () => import('@/views/UserRoles.vue'),
          beforeEnter: authenticationGuard,
          meta: { authorizedRoles: [UserRoleName.TraceAdmin, UserRoleName.SupportAccess, UserRoleName.CompanyAdmin] },
        },
        {
          path: '/user-roles/:userRoleId',
          name: 'user-role',
          component: () => import('@/views/UserRole.vue'),
          beforeEnter: authenticationGuard,
          meta: { authorizedRoles: [UserRoleName.TraceAdmin, UserRoleName.SupportAccess, UserRoleName.CompanyAdmin] },
        },
      ],
    },
    {
      path: '*',
      redirect: { name: 'application-modules' },
    },
  ],
});

export default router;
